import React from 'react';
import Helmet from 'react-helmet';
import './legal.css';

const PrivacyPolicyPage = () => (
  <div className="legal-shell">
    <Helmet>
      <title>Privacy Policy | Coetic X</title>
      <meta
        name="description"
        content="Coetic X privacy policy explaining what we collect, how we use it, and your rights."
      />
    </Helmet>
    <div className="legal-card">
      <div className="legal-meta">
        <span className="legal-eyebrow">Legal</span>
        <h1>Privacy Policy</h1>
        <p className="legal-date">Effective: Jan 1, 2026</p>
        <p className="legal-lead">
          We respect privacy and keep data use intentional, minimal, and purpose-driven. This policy
          explains what we collect and how we use it when you visit our website or contact us.
        </p>
      </div>

      <section className="legal-section">
        <h2>Information we collect</h2>
        <p>
          We collect information you submit directly, such as name, email address, and project details.
          We also receive basic technical data (browser, device, IP, and usage patterns) to improve site
          performance and security.
        </p>
      </section>

      <section className="legal-section">
        <h2>How we use information</h2>
        <ul>
          <li>Respond to inquiries and deliver requested services.</li>
          <li>Improve site content, performance, and user experience.</li>
          <li>Maintain security and prevent misuse.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>Cookies and analytics</h2>
        <p>
          We may use cookies or similar technologies to understand site usage and improve reliability.
          You can control cookies through your browser settings at any time.
        </p>
      </section>

      <section className="legal-section">
        <h2>Sharing and retention</h2>
        <p>
          We do not sell personal data. We share information only with trusted providers needed to
          operate the site or deliver services. We retain data only as long as necessary for the purposes
          described here.
        </p>
      </section>

      <section className="legal-section">
        <h2>Your rights</h2>
        <p>
          You may request access, correction, or deletion of your information. Contact us at&nbsp;
          <a href="mailto:arber@coetic-x.com">arber@coetic-x.com</a>.
        </p>
      </section>

      <section className="legal-section">
        <h2>Policy updates</h2>
        <p>
          We may update this policy as our services evolve. Updates will be reflected on this page.
        </p>
      </section>
    </div>
  </div>
);

export default PrivacyPolicyPage;
